const selectors = {
	customerAddresses: '[data-customer-addresses]',
	addressCountrySelect: '[data-address-country-select]',
	deleteAddressButton: 'button[data-confirm-message]',
};
const attributes = {
	expanded: 'aria-expanded',
	confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
	constructor() {
		this.elements = this._getElements();
		if (Object.keys(this.elements).length === 0) return;
		this._setupCountries();
		this._setupEventListeners();
	}

	_getElements() {
		const container = document.querySelector(selectors.customerAddresses);
		return container
			? {
					container,
					deleteButtons: container.querySelectorAll(
						selectors.deleteAddressButton,
					),
					countrySelects: container.querySelectorAll(
						selectors.addressCountrySelect,
					),
				}
			: {};
	}

	_setupCountries() {
		if (Shopify && Shopify.CountryProvinceSelector) {
			// eslint-disable-next-line no-new
			this.elements.countrySelects.forEach((select) => {
				const formId = select.dataset.formId;
				// eslint-disable-next-line no-new
				new Shopify.CountryProvinceSelector(
					`AddressCountry_${formId}`,
					`AddressProvince_${formId}`,
					{
						hideElement: `AddressProvinceContainer_${formId}`,
					},
				);
			});
		}
	}

	_setupEventListeners() {
		this.elements.deleteButtons.forEach((element) => {
			element.addEventListener('click', this._handleDeleteButtonClick);
		});
	}

	_handleDeleteButtonClick = ({currentTarget}) => {
		// eslint-disable-next-line no-alert
		if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
			Shopify.postLink(currentTarget.dataset.target, {
				parameters: {
					_method: 'delete',
				},
			});
		}
	};
}

if (
	document.readyState === 'complete' ||
	document.readyState === 'loaded' ||
	document.readyState === 'interactive'
) {
	// document ready
	new CustomerAddresses();
} else {
	new CustomerAddresses();
}
